/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GamePlayerEngineDto } from './gamePlayerEngineDto';
import { StepDto } from './stepDto';

export interface GameLightDto { 
    id?: number;
    name?: string;
    description?: string;
    status?: GameLightDto.StatusEnum;
    winnerCivilizationName?: string;
    rulesUuid?: string;
    boardUuid?: string;
    rulesId?: number;
    rulesName?: string;
    rulesLocalizedNames?: { [key: string]: string; };
    rulesLocalizedDescriptions?: { [key: string]: string; };
    boardStartId?: number;
    creatorUuid?: string;
    creatorName?: string;
    creatorUsername?: string;
    step?: StepDto;
    playersCount?: number;
    players?: Array<GamePlayerEngineDto>;
    simpleHistorySize?: number;
    version?: number;
    createdDate?: Date;
    lastModifiedDate?: Date;
}
export namespace GameLightDto {
    export type StatusEnum = 'CREATED' | 'STARTED' | 'INTERRUPTED' | 'FINISHED';
    export const StatusEnum = {
        CREATED: 'CREATED' as StatusEnum,
        STARTED: 'STARTED' as StatusEnum,
        INTERRUPTED: 'INTERRUPTED' as StatusEnum,
        FINISHED: 'FINISHED' as StatusEnum
    };
}